import type { FC } from "react";
import type { IAppHeaderWithMarkerProps } from "app/components/React/Table/headerCells/AppHeaderWithMarker";
import { AppHeaderWithMarker } from "app/components/React/Table/headerCells/AppHeaderWithMarker";

export const AppHeaderRightAligned: FC<IAppHeaderWithMarkerProps> = (props) => {
    return (
        <AppHeaderWithMarker
            {...props}
            isRightAligned={true}
        />
    );
};

AppHeaderRightAligned.displayName = "AppHeaderRightAligned";
